import React from "react"

import { IActionMessage, IHTMLMessage } from "../.."

import ActionMessage from "./ActionMessage"
import HTMLMessage from "./HTMLMessage"

export interface Props {
    message: IActionMessage | IHTMLMessage
    isLoading: boolean
}

export default function Message({ isLoading, message }: Props): JSX.Element {
    const { id, type, isSentByUser } = message

    const sharedDataProps = {
        "data-ft-component": "message",
        "data-ft-type": type,
        "data-ft-id": id,
        "data-ft-is-sent-by-user": isSentByUser,
    }

    if (type === "Action") {
        return (
            <ActionMessage
                {...sharedDataProps}
                {...message}
                isLoading={isLoading}
            />
        )
    } else if (type === "HTML") {
        return <HTMLMessage {...sharedDataProps} {...message} />
    }

    return <></>
}
